"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logJobSummary = exports.writeJobSummary = void 0;
const core = __importStar(require("@actions/core"));
const cache_reporting_1 = require("./cache-reporting");
function writeJobSummary(buildResults, cacheListener) {
    return __awaiter(this, void 0, void 0, function* () {
        core.info('Writing job summary');
        if (buildResults.length === 0) {
            core.debug('No Gradle build results found. Summary table will not be generated.');
        }
        else {
            writeSummaryTable(buildResults);
        }
        (0, cache_reporting_1.writeCachingReport)(cacheListener);
        yield core.summary.write();
    });
}
exports.writeJobSummary = writeJobSummary;
function logJobSummary(buildResults, cacheListener) {
    return __awaiter(this, void 0, void 0, function* () {
        if (buildResults.length === 0) {
            core.debug('No Gradle build results found. Summary table will not be logged.');
        }
        else {
            logSummaryTable(buildResults);
        }
        (0, cache_reporting_1.logCachingReport)(cacheListener);
    });
}
exports.logJobSummary = logJobSummary;
function writeSummaryTable(results) {
    core.summary.addHeading('Gradle Builds', 3);
    core.summary.addRaw(`
<table>
    <tr>
        <th>Root Project</th>
        <th>Requested Tasks</th>
        <th>Gradle Version</th>
        <th>Build Outcome</th>
        <th>Build Scan®</th>
    </tr>${results.map(result => renderBuildResultRow(result)).join('')}
</table>
    `);
}
function renderBuildResultRow(result) {
    return `
    <tr>
        <td>${result.rootProjectName}</td>
        <td>${result.requestedTasks}</td>
        <td align='center'>${result.gradleVersion}</td>
        <td align='center'>${renderOutcome(result)}</td>
        <td>${renderBuildScan(result)}</td>
    </tr>`;
}
function renderOutcome(result) {
    return result.buildFailed ? ':x:' : ':white_check_mark:';
}
function renderBuildScan(result) {
    if (result.buildScanFailed) {
        return renderBuildScanBadge('PUBLISH_FAILED', 'orange', 'https://docs.gradle.com/enterprise/gradle-plugin/#troubleshooting');
    }
    if (result.buildScanUri) {
        return renderBuildScanBadge('PUBLISHED', '06A0CE', result.buildScanUri);
    }
    return renderBuildScanBadge('NOT_PUBLISHED', 'lightgrey', 'https://scans.gradle.com');
}
function renderBuildScanBadge(outcomeText, outcomeColor, targetUrl) {
    const badgeUrl = `https://img.shields.io/badge/Build%20Scan%C2%AE-${outcomeText}-${outcomeColor}?logo=Gradle`;
    const badgeHtml = `<img src="${badgeUrl}" alt="Build Scan ${outcomeText}" />`;
    return `<a href="${targetUrl}" rel="nofollow">${badgeHtml}</a>`;
}
function logSummaryTable(results) {
    core.info('============================');
    core.info('Gradle Builds');
    core.info('----------------------------');
    core.info('Root Project | Requested Tasks | Gradle Version | Build Outcome | Build Scan®');
    core.info('----------------------------');
    for (const result of results) {
        core.info(`${result.rootProjectName} | ${result.requestedTasks} | ${result.gradleVersion} | ${result.buildFailed ? 'FAILED' : 'SUCCESS'} | ${result.buildScanFailed ? 'Publish failed' : result.buildScanUri}`);
    }
    core.info('============================');
}
